import styled, { css } from "styled-components";

export const Bar = styled.div`
  width: 100%;
  margin: 5px 10px;
  display: flex;
  align-items: center;
`;
